export class RegepRegulatoryDataSectionsState {
  constructor(state?: any) {
    this.application_id = state?.application_id;

    this.is_waiver_of_feed_in_compensation_locked = state ? JSON.parse(state.is_waiver_of_feed_in_compensation_locked) : null;
    this.waiver_of_feed_in_compensation_comment = state?.waiver_of_feed_in_compensation_comment;

    this.is_models_for_feed_in_compensation_locked = state ? JSON.parse(state.is_models_for_feed_in_compensation_locked) : null;
    this.models_for_feed_in_compensation_comment = state?.models_for_feed_in_compensation_comment;

    this.is_bank_account_details_locked = state ? JSON.parse(state.is_bank_account_details_locked) : null;
    this.bank_account_details_comment = state?.bank_account_details_comment;

    this.is_declaration_on_vat_payment_locked = state ? JSON.parse(state.is_declaration_on_vat_payment_locked) : null;
    this.declaration_on_vat_payment_comment = state?.declaration_on_vat_payment_comment;

    this.is_marktstammdatenregister_registration_locked = state ? JSON.parse(state.is_marktstammdatenregister_registration_locked) : null;
    this.marktstammdatenregister_registration_comment = state?.marktstammdatenregister_registration_comment;

    this.is_bafa_authorization_notice_locked = state ? JSON.parse(state.is_bafa_authorization_notice_locked) : null;
    this.bafa_authorization_notice_comment = state?.bafa_authorization_notice_comment;
  }

  application_id: number | null;

  is_waiver_of_feed_in_compensation_locked: boolean | null;
  waiver_of_feed_in_compensation_comment: string | null;

  is_models_for_feed_in_compensation_locked: boolean | null;
  models_for_feed_in_compensation_comment: string | null;

  is_bank_account_details_locked: boolean | null;
  bank_account_details_comment: string | null;

  is_declaration_on_vat_payment_locked: boolean | null;
  declaration_on_vat_payment_comment: string | null;

  is_marktstammdatenregister_registration_locked: boolean | null;
  marktstammdatenregister_registration_comment: string | null;

  is_bafa_authorization_notice_locked: boolean | null;
  bafa_authorization_notice_comment: string | null;
}
